import ResponsiveImage from '../../../components/ResponsiveImage';

interface IImage {
  src: string;
  alt?: string | null;
}

export enum IMAGE_VIEWER_PREVIEW_SIZE {
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

interface ImageViewerPreviewProps {
  images: IImage[];
  selectedSlide: number;
  onPreviewClick?: (index: number) => void;
  isHorizontal?: boolean;
  size?: IMAGE_VIEWER_PREVIEW_SIZE;
  UNSAFE_className?: string;
}

const ImageViewerPreview = ({
  images,
  selectedSlide = 0,
  onPreviewClick,
  isHorizontal = false,
  size = IMAGE_VIEWER_PREVIEW_SIZE.MEDIUM,
  UNSAFE_className = '',
}: ImageViewerPreviewProps) => {
  return (
    <ul
      className={`image-viewer-preview tw-mr-4 tw-hidden min-[960px]:tw-block ${
        isHorizontal ? 'tw-justify-center tw-gap-2 min-[960px]:tw-flex' : ''
      } ${UNSAFE_className}`}
      role="tablist"
    >
      {images.map((image, index) => {
        return (
          <li
            key={index}
            className={`tw-mb-4 
            ${
              size === IMAGE_VIEWER_PREVIEW_SIZE.SMALL
                ? 'tw-h-[48px] tw-w-[48px]'
                : 'tw-h-[78px] tw-w-[78px]'
            }
            tw-overflow-hidden tw-rounded tw-border
            tw-border-solid tw-border-blue-200
            ${selectedSlide === index ? 'tw-border-yellow-600' : ''}`}
          >
            <button
              type="button"
              className="tw-lf-button-clear"
              role="tab"
              aria-selected={selectedSlide === index ? 'true' : 'false'}
              aria-controls={`image-viewer-panel-${index}`}
              onClick={() => {
                onPreviewClick?.(index);
              }}
            >
              <ResponsiveImage
                width={76}
                height={76}
                src={image.src}
                alt={image.alt || ''}
                objectFit="contain"
              />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ImageViewerPreview;
